export default {"src":"/_next/static/media/geek-logo.5e162598.svg","height":34,"width":231};